export default __webpack_public_path__ + "static/ActivityCardBarber-aa1ea801aed28179a6e8acd07f9d5626.png";